import "./Home.scss";
import illustration1 from "assets/home-illustration-1.png";
import illustration2 from "assets/home-illustration-2.png";
import { Button } from "@mui/material";
import { NewsletterForm } from "components";
import { useNavigate } from "react-router-dom";
import { CONSTANTS } from "utils";
import { INewsletterForm } from "components/Home/NewsletterForm/NewsletterForm.config";
import { useCreateNewsletterSubMutation } from "state/api/landingApi";

export const Home = () => {

  const navigate = useNavigate();

  const [ createNewsletter ] = useCreateNewsletterSubMutation();

  const onPressKnowMoreHandler = () => {
    navigate(CONSTANTS.PAGES.ABOUT_US);
  };

  const onCompletedFormHandler = (values: INewsletterForm) => {
    createNewsletter(values);
  };

  return (
    <div className="home-container">
      <div className="title-container">
        <img src={illustration1} alt="illustration1" />
        <div>
          <span className="text-title">Una nueva manera de ahorrar</span>
          <Button onClick={onPressKnowMoreHandler} sx={{ width: "240px", height: "40px" }}>Saber mas</Button>
        </div>

      </div>
      <div className="just-time-rent-container">
        <div>
          <span className="text-title">Alquila tus artículos el tiempo que necesites</span>
        </div>
      </div>
      <div className="who-we-are">
        <div>
          <span className="text-title">¿Qué somos?</span>
          <div>
            <p>Somos un marketplace de alquiler donde podrás ceder tus artículos por tiempo limitado con opción de compra si el arrendatario lo desea. </p>
            <br />
            <p> También podrás alquilar los artículos de otros usuarios para ahorrar en tus compras y pagar únicamente por lo que realmente necesitas. </p>
          </div>
          <Button onClick={onPressKnowMoreHandler} sx={{ width: "240px", height: "40px" }}>Saber mas</Button>
        </div>
        <img src={illustration2} alt="illustration2" />
      </div>
      <div className="scale-your-bussiness">
        <div>
          <span className="text-title">Escala tu negocio con Lendit</span>
          <Button onClick={onPressKnowMoreHandler} sx={{ width: "240px", height: "40px" }}>Saber mas</Button>
        </div>
      </div>
      <div className="newsletter-section">
        <div>
          <span className="text-title">¿Quiéres estar al día?</span>
          <p>Únete a nuestra newsletter aquí</p>
          <div>
            <NewsletterForm onCompletedForm={onCompletedFormHandler} />
          </div>
        </div>
      </div>
    </div>
  );
};